import { render, staticRenderFns } from "./resetPosition.vue?vue&type=template&id=89f0e3ec&scoped=true"
import script from "./resetPosition.vue?vue&type=script&lang=js"
export * from "./resetPosition.vue?vue&type=script&lang=js"
import style0 from "./resetPosition.vue?vue&type=style&index=0&id=89f0e3ec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89f0e3ec",
  null
  
)

export default component.exports